const r = "arrow_-kLfT", o = "leftArrow_cHqUi", t = "rightArrow_xMqik", w = {
  arrow: r,
  leftArrow: o,
  rightArrow: t
};
export {
  r as arrow,
  w as default,
  o as leftArrow,
  t as rightArrow
};
//# sourceMappingURL=horizontalScroller.module.scss.js.map
